<script>
export default {
  props: ['value'],
  computed: {
    active(){
      return this.$store.get('series_filter') == this.value;
    }
  },
  methods: {
    setFilter(value){
      this.$store.set("toggleFilter", {filter: "series_filter", value: this.value})
    }
  }
};
</script>


<template>
  <div class="filter-button small" @click="setFilter(value)" :class="{active}">
    <img :src="'./icons/'+value+'W.svg'" :style="{width: '4rem', paddingTop: '0.25rem'}"/>
  </div>
</template>